import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "./ProductDetails/ProductHeader";
import List from "./Menu/List";
import instance from "../store/actions/instance";
import { CircularProgress } from "@material-ui/core";
import { saveSearch } from "../store/actions/store";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import MList from "@material-ui/core/List";
import ListItem from "./Menu/ListItem";
import Fuse from "fuse.js";
import { sortSmartSearchResult } from "./Menu/Helpers";
import FeedbackCard from "./Branches/Feedbacks/FeedbackCard";
import InfiniteScroll from "react-infinite-scroller";
import JumboListItem from "./JumboMenu/ListItem";
import { useHistory } from "react-router-dom";

const search = (params, val) =>
  instance.post(`/search_products/${val}/`, { ...params });
const searchDebounced = AwesomeDebouncePromise(search, 1000);

export class Search extends Component {
  container = React.createRef();
  state = {
    isEmpty: false,
    filter_value: "",
    productsList: [],
    searchLoading: false,
    pageLoaded: 1,
    searchPages: 1,
  };
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const looking = params.get("q");
    if (looking) {
      this.setState({ filter_value: looking });
      this.search(looking);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.container.current &&
      this.container.current.getBoundingClientRect().height === 0 &&
      this.state.isEmpty === false
    ) {
      this.setState({ isEmpty: true });
    }

    if (
      prevProps.secondLoading != this.props.secondLoading &&
      this.state.filter_value != ""
    ) {
      this.search(this.state.filter_value);
    }
  }
  updateURL(filter_value) {
    const { history } = this.props;

    if (filter_value) {
      history.replace(`/search?q=${encodeURIComponent(filter_value)}`);
    } else if (filter_value == "") {
      history.replace("/search");
    } else {
      history.replace("/search");
    }
  }

  search = async (val, fromInfiniteScroll = false) => {
    const { settings, branch, secondLoading, usedComponents } = this.props;
    if (!fromInfiniteScroll) {
      this.setState({
        searchLoading: true,
        productsList: [],
        pageLoaded: 1,
        searchPages: 1,
      });
    }
    let res;

    const availableCategories = this.props.categories.map(
      (category) =>
        !["newest", "most-selling", "discount-products"].includes(
          category.id
        ) && category.id
    );
    if (settings.is_branch_based_ordering && (branch.branch || branch.bdc)) {
      res = await searchDebounced(
        {
          type: branch.isPickup ? "pickup" : "delivery",
          branch_id: branch.branch,
          bdc_id: !branch.isPickup ? branch.bdc : branch.branch,
          used_components: usedComponents,
          availableCategories: availableCategories,
          country_code: this.props.country_code,
          pages_loaded: fromInfiniteScroll ? this.state.pageLoaded + 1 : 1,
          channel: this.props.channel,
        },
        val
      );
    } else {
      res = await searchDebounced(
        {
          used_components: usedComponents,
          availableCategories: availableCategories,
          country_code: this.props.country_code,
          pages_loaded: fromInfiniteScroll ? this.state.pageLoaded + 1 : 1,
          channel: this.props.channel,
        },
        val
      );
    }
    const data = res.data;
    if (data.products.length) {
      this.setState({
        productsList: fromInfiniteScroll
          ? [...this.state.productsList, ...res.data.products]
          : res.data.products,
        searchLoading: false,
        isEmpty: false,
        searchPages: res.data.pages,
        pageLoaded: fromInfiniteScroll
          ? this.state.pageLoaded + 1
          : res.data.pages_loaded,
      });

      this.props.saveSearch(res.data.products);
    } else {
      this.setState({ productsList: [], searchLoading: false });
    }
  };
  filter = async (filter_value) => {
    const { settings, secondLoading } = this.props;

    this.setState({
      filter_value,
      isEmpty: false,
      pageLoaded: 1,
      searchPages: 1,
    });
    this.updateURL(filter_value);
    if (secondLoading) {
      this.setState({ searchLoading: true });
    }
    if (!secondLoading) {
      if (settings.store_layout != "list") {
        if (filter_value) this.search(filter_value, false);
        else this.setState({ productsList: [] });
      }
    }
  };

  getProductList = () => {
    const options = {
      threshold: 0.39,
      keys:
        this.props.settings.enable_smart_search &&
        this.props.settings.enable_smart_search_staff
          ? [
              "name",
              "ar_name",
              "description",
              "ar_description",
              "short_description",
              "ar_short_description",
            ]
          : ["name", "ar_name"],
    };
    const products = this.props.categories
      .map((category) => category.products)
      .flat(1);
    const fuse = new Fuse(products, options);
    let result = fuse.search(this.state.filter_value || "");
    result = result
      .map((product) => product.item)
      .filter((product) => product !== undefined);
    if (
      this.props.settings.enable_smart_search &&
      this.props.settings.enable_smart_search_staff
    ) {
      result.sort((a, b) =>
        sortSmartSearchResult(a, b, this.state.filter_value)
      );
    }
    return result;
  };

  render() {
    const { settings } = this.props;
    let productToDisplay = [];

    const Item = settings.store_layout === "jumbo" ? JumboListItem : ListItem;
    if (settings.store_layout === "list") {
      const fuseProducts = this.getProductList();
      productToDisplay = fuseProducts.map((product) => (
        <Item
          product={product}
          isFilter={false}
          isSearch={true}
          filter_value={this.state.filter_value.toLowerCase()}
          category={product.category}
          key={"ListItem_Menu" + product.id}
          category_id={product.category_id}
        />
      ));
    } else {
      productToDisplay = this.state.productsList.map((category) => (
        <Item
          product={category}
          isFilter={false}
          isSearch={true}
          filter_value={this.state.filter_value.toLowerCase()}
          category={category.category}
          key={"ListItem_Menu" + category.id}
          category_id={category.category_id}
        />
      ));
    }
    return (
      <div style={{ backgroundColor: "white", minHeight: window.innerHeight }}>
        <ProductHeader
          Search={true}
          value={this.state.filter_value}
          filter={this.filter}
          style={{ backgroundColor: "white" }}
          onBack={() => {
            this.props.history.length > 2
              ? this.props.history.goBack()
              : this.props.history.replace("/");
          }}
        />
        <div
          className="free-space-58"
          style={{ backgroundColor: "white" }}
        ></div>

        {this.state.filter_value === "" ? (
          <p className="text-muted mt-5">
            {this.props.language === "english"
              ? "Search for a product"
              : "ابحث عن منتج"}
          </p>
        ) : (
          <div ref={this.container}>
            {!this.state.isEmpty ? (
              settings.store_layout === "list" ? (
                productToDisplay
              ) : (
                <InfiniteScroll
                  useWindow={true}
                  loadMore={() => this.search(this.state.filter_value, true)}
                  hasMore={this.state.searchPages !== this.state.pageLoaded}
                  loader={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 15,
                      }}
                    >
                      <CircularProgress
                        color="primary"
                        style={{ marginTop: 15, marginBottom: 15 }}
                      />
                    </div>
                  }
                >
                  {productToDisplay}
                </InfiniteScroll>
              )
            ) : this.state.searchLoading ? (
              <CircularProgress color="primary" style={{ marginTop: 30 }} />
            ) : (
              <p className="text-muted mt-5">
                {this.props.language === "english"
                  ? "No products were found"
                  : "لم يتم العثور على اي منتج"}
              </p>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    enable_search: state.store.enable_search,
    categories: state.store.store.categories,
    settings: state.store.store.settings,
    branch: state.branch,
    secondLoading: state.store.secondLoading,
    usedComponents: state.store.used_components,
    customers: state.customers,
    country_code: state.currency.selected,
    channel: state.promise.src,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveSearch: (categories) => dispatch(saveSearch(categories)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
